import { getElement, store, getContext } from '@wordpress/interactivity';

store( 'accordion', {
	actions: {
		toggle: () => {
			const context = getContext();
			context.isOpen = ! context.isOpen;
			
			const { ref } = getElement();
            const content = ref.nextElementSibling;

            if ( context.isOpen ) {

                // close other accordions if toggle-all is active
                if ( ref.parentElement.parentElement.classList.contains('toggle-all') ) {
                    ref.parentElement.parentElement.querySelectorAll('.accordion-title').forEach( (accordion) => {
                        
                        if ( accordion.parentElement.classList.contains('active') ) {
                            accordion.click();
                        }
                    }); 
                }
                
                // add class to parent element
                ref.parentElement.classList.add('active');
                content.style.maxHeight = content.scrollHeight + 'px';
                
            } else {
                // remove class from parent element
                ref.parentElement.classList.remove('active');
                content.style.maxHeight = '0px';
            }

		},
	}, 
    callbacks: { 
        isOpenState: () => { 
			const context = getContext(); 
			
			const { ref } = getElement(); 
            const content = ref.querySelector('.accordion-content');

            if ( context.isOpen ) { 
                content.style.maxHeight = content.scrollHeight + 'px'; 
            } 
        }, 
    }, 
}); 